import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
const json = {
 
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "",
    video: "",
    // recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E2answerKey.jpg",
    component: Circle_Write,

    titleQuestion: [
      {
        num: "",
        title: `
			<img src='/img/FriendsPlus/Page2/E2/1.jpg' style='height:15mm;margin-right:50px' /> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
		question: {
			Write: {
				inputStyle: { width:750, padding: 20 },
				answers: [],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: { border: 'none', borderRadius: '50%', borderColor: 'transparent', fontWeight: 'bold' },
				// initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
				selectWordStyle: {padding:"5px", border: '2px solid', borderColor: 'gray' },
				limitSelect: 1,
				listWords: [
					`A|. <br> B|. <br> C|. `,
					`A. <br> B. <br> C. <br> D.`,
					`A. <br> B. <br> C. <br> D.`,
					
				],
				answers: ['0-0', '1-0', '2-0', '3-4', '4-4', '5-0', '6-0', '7-4', '8-0'],

				initialValue: [],
			},
			Layout: `
    <div style='width:20cm;margin-left:50px'>
          &emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
          nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
          dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
          Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
          <br>
          &emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
          Còn anh cậu chẳng bận tâm đến chuyện đó.
          <br>
          &emsp;Một lần, hai anh em tham gia hội thao của trường. Long vô cùng lo lắng. 
          Hai anh em mặc đồng phục và đội mũ giống hệt nhau, bạn bè lại cổ vũ nhầm mất thôi. 
          Nhưng khi thi đấu, Long nhận ra các bạn không nhầm lẫn chút nào. Các bạn cổ vũ Long 
          đuổi theo Khánh khi Khánh dẫn đầu đường chạy. Các bạn cuống quýt gọi Khánh thay thế khi thấy 
          Long nhăn nhó vì đau trong trận kéo co... Hội thao kết thúc trong nỗi ngạc nhiên ngập tràn của Long.
          <br>
          &emsp;Trên đường về, Long hỏi Vân: <br>
          &emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
          <br>
          &emsp;Vân khúc khích<br>
          &emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
          &emsp;Vĩng chen vào: <br>
          &emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
          &emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
          &emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
          &emsp;Anh Khánh lúc đó mới lên tiếng: <br>
          &emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
          &emsp;Tiếng cười rộn rã làm tan biến mọi thắc mắc của Long. Cậu cũng phá lên cười. Cậu hiểu ra: Cậu vẫn là cậu, anh Khánh vẫn là anh Khánh, hai anh em chỉ giống nhau bề ngoài thôi.

      <div style='text-align: end'>(Châu Khuê)</div>
    </div>

    <div style='display:flex;margin-top:20px'>
      <img src='/img/FriendsPlus/Page3/E1/1.jpg' style='height:15mm;margin-right:20px' />
      <div style='width:20cm'>
          <b style='color:rgb(151 30 17)'>1.</b>&ensp;Long và Khánh được giới thiệu như thế nào?<br><input id='0'></input><br>
          <b style='color:rgb(151 30 17)'>2.</b>&ensp;Những chi tiết nào thể hiện cảm xúc và hành động của Long khi thấy mình giống anh?<br><input id='1'></input><br>
        <div>
          <b style='color:rgb(151 30 17)'>3.</b>&ensp;Theo em vì sao Long không muốn giống anh của mình? Chọn câu trả lời dưới đây hoặc nêu ý kiến của em.<br>
          <div style='display:flex;margin:0px 25px'>
            <div>
              <input id='0' type='Circle'/>
            </div>
            <div style='margin:0px 5px'>
              Vì Long không thích bị mọi người gọi nhầm.<br>
              Vì Long cảm thấy phiền hà khi giống người khác.<br>
              Vì Long muốn khẳng định vẻ riêng của mình.
            </div>
          </div>
        </div>
          <b style='color:rgb(151 30 17)'>4.</b>&ensp;Nhờ nói chuyện với các bạn, Long đã nhận ra mình khác anh như thế nào?<br><input id='2'></input><br>
          <b style='color:rgb(151 30 17)'>5.</b>&ensp;Nhận xét về đặc điểm của Long và Khánh thể hiện qua hành động, lời nói của từng nhân vật.<br><input id='3'></input><br>
      </div>
    </div>
			


        
         `,
		},},
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page4/Key/E3answerKey.jpg",
    component: T6,
    // maxLength: 1,
    fontSize:30,
    inputSize: 220,
    titleQuestion: [
      {
        num: "3",
        title: `Complete the sentences with the 
        correct verbs.`,
        color: "rgb(3, 103, 181)",
        star:2
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
          <div>
            <div>Mum and Dad always <b>cook</b>
            on weekdays, but sometimes I 
            do it at the weekend. I normally 
            make pasta and salad for dinner.</div>
            <div><strong style="margin-right:15px">1</strong>I don’t usually # immediately after waking up. 
            I like to stay in bed for a few minutes and think 
            about my day.</div>
            <div><strong style="margin-right:15px">2</strong>I always # before school. I often 
            have juice, some toast and some fruit. Then I’m 
            not hungry until lunchtime.</div>
            <div><strong style="margin-right:15px">3</strong>I usually # as soon as I get home 
            from school. When it’s finished, I can enjoy the 
            rest of my evening.</div>
            <div><strong style="margin-right:15px">4</strong>I try to # for a 
            while every day. Sometimes I 
            go for a walk, and other times I 
            watch videos or listen to music.</div>
            <div><strong style="margin-right:15px">5</strong>I don’t # very often 
            because I haven’t got much money to spend. I 
            sometimes go running with my friends instead. 
            We like exercising.</div>
            <div><strong style="margin-right:15px">6</strong>I # every morning by bus. It takes 
            about twenty-five minutes. The bus arrives at 
            8.05, and lessons start at 9.00, so I’m never late.</div>
            
          </div>
        `,
        answer: [" get up"," have breakfast","do my homework", "relax", "go shopping", "go to school"],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E4",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "",
    component: T6,
    // maxLength: 1,
    fontSize:30,
    hideBtnFooter:true,
    textareaStyle:{width:'900px'},
    inputSize: 630,
    titleQuestion: [
      {
        num: "4",
        title: `Write four or five complete sentences 
        comparing your typical daily routine with what 
        you do on holiday. What’s the same and what’s 
        different?`,
        color: "rgb(3, 103, 181)",
        star:3
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
          <div>
           <div><strong>I always wake up at 6.30 on weekdays and at around
           8.30 at the weekend. When I’m on holiday, I usually 
           get up later ...</strong></div>
           <div><textarea id="0" rows="6"></textarea></div>
          </div>
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
